import { styled } from "@pigment-css/react";
import { glassCapsulePress } from "@acto/taskpane/field-sales-2/styles/glassCapsulePress";

/** Also the width of BottomSheet's header spacer, which balances the centred sheet title. */
export const HEADER_ICON_BUTTON_WIDTH = "3.75rem";

/** The header close / back / action icon button: a 60×48 glass stadium pill. Icon and behaviour are the caller's. */
export const HeaderIconButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: HEADER_ICON_BUTTON_WIDTH,
  height: theme.fieldSalesTwo.spacing[48],
  padding: 0,
  margin: 0,
  border: `${theme.strokeWidth.thin} solid ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
  borderRadius: theme.fieldSalesTwo.radius.circular,
  background: theme.fieldSalesTwo.colors.surface.glassMedium,
  backdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  WebkitBackdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  boxShadow: theme.fieldSalesTwo.shadows.glass,
  color: theme.fieldSalesTwo.colors.neutral[900],
  cursor: "pointer",
  ...glassCapsulePress(theme, { restShadow: theme.fieldSalesTwo.shadows.glass }),
}));
